<template>
  <!-- Loading -->
  <div class="vld-parent">
    <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128"/>
  </div>

  <!-- <main-section>
      <div class="filter-content mb-4" :class="[isAsideMobileExpanded ? 'filter-content-wide' : '']">
          <field :label="$t('class.department')" class="px-3">
            <control :options="departmentList" :placeholder="$t('class.placeholder.department')" v-model="filtered.department_id" />
          </field>
          <field :label="$t('class.academicYear')" class="px-3">
            <control :options="academicYearListFilter" :placeholder="$t('class.academicYear')" v-model="filtered.academic_year_id" />
          </field>
          <field :label="$t('class.title')" class="px-3">
            <control :options="classListFilter" :placeholder="$t('class.placeholder.class')" v-model="filtered.class_id" />
            <jb-button label="Search" color="info" :icon="mdiMagnify" small @click="getData()" class="w-auto md:w-2/3 mx-auto md:mx-0 md:-ml-1 rounded-xl md:rounded py-2 px-8 mb-6 md:mb-0" />
          </field>
        </div> -->

      <div class="full-container_">
            <!-- looping major -->
            <div class="sub-container" v-for="filter in filterData.value" :key="filter" :style="'border: 3px solid'+getRandomColor()+';'">
                <div class="title-group">
                  {{ filter.description }}
                </div>

                <div class="container-group" v-for="group in Object.keys(dataGroup.value).filter((item) => item === filter.major_id)" :key="group">
                  <!-- looping subject group -->
                    <div class="card-group" v-for="subjectGroup in Object.keys(dataGroup.value[group])" :key="subjectGroup">
                        <div class="header-content" style="text-decoration-line: underline;">
                          {{ subjectGroupList.value.filter(item=>item.subject_group_id === subjectGroup)[0].group_name }}
                        </div>

                        <div class="sub-content">
                          <!-- looping data class -->
                            <div class="content" v-for="subject in dataGroup.value[group][subjectGroup]" :key="subject" :style="'border: 0px solid; background-color:'+(subject.persen==100?'#c4c4c4':subject.set_color) +';' ">
                                <div class="title-content" :style="'color:'+(subject.font_color)">
                                  {{ subject.name }}
                                </div>

                                <div v-for="datax in subject.timeList" :key="datax" class="flex flex-col" :style="'color:'+(subject.font_color)">
                                  <div>{{ datax.day }} : </div>
                                  <div>{{ datax.time1 }} - {{ datax.time2 }}</div>
                                </div>
                                <!-- <table>
                                  <tr v-for="datax in subject.timeList" :key="datax">
                                    <td>{{ datax.day }}</td>
                                    <td> : </td>
                                    <td>{{ datax.time1 }} - {{ datax.time2 }}</td>
                                  </tr>
                                </table> -->
                                <div class="text-xs pt-3 mt-3" :style="'color:'+(subject.font_color)">
                                  {{ subject.already }}  /  {{ subject.capacity }}
                                </div>
                                <div class="bar-capacity">
                                    <!-- <div class="bar-value"></div> -->
                                  <div :style="'width:' + subject.persen + '%;'" class="bar-percentage bar-gray" v-if="subject.persen <= 0"></div>
                                  <div :style="'width:' + subject.persen + '%;'" class="bar-percentage bar-green" v-if="subject.persen <= 50"></div>
                                  <div :style="'width:' + subject.persen + '%;'" class="bar-percentage bar-yellow" v-else-if="subject.persen >= 51 && subject.persen <= 80"></div>
                                  <div :style="'width:' + subject.persen + '%;'" class="bar-percentage bar-red" v-else-if="subject.persen >= 81 && subject.persen <= 100"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      </div>

  <!-- </main-section> -->
</template>

<script>
  // @ is an alias to /src
  import axios from 'axios'
  import {
    computed,
    ref,
    onMounted,
    reactive,
    watchEffect,
    watch
  } from 'vue'
  import {
    useStore
  } from 'vuex'
  import { useToast } from 'vue-toastification'
  import {
    mdiAccountMultiple,
    mdiCartOutline,
    mdiChartTimelineVariant,
    mdiFinance,
    mdiMonitorCellphone,
    mdiReload,
    mdiGithub,
    mdiMagnify,
    mdiClose,
    mdiCogOutline,
    mdiTrashCan
  } from '@mdi/js'
  import { getDepartmentData, getClassData, getAcademicYearData } from '@/composables/global'
  import '@vuepic/vue-datepicker/dist/main.css'
  // import Field from '@/components/Field'
  // import MainSection from '@/components/MainSection'
  // import JbButton from '@/components/JbButton'
  import { useI18n } from 'vue-i18n'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import { useRouter } from 'vue-router'
  // import Control from '@/components/Control'
  export default {
    name: 'Subject Selection',
    components: {
      // Field,
      // MainSection,
      // JbButton,
      Loading
      // Control
    },
    mounted () {
      this.backgroundColor = this.getRandomColor()
    },
    methods: {
      getRandomColor () {
        const min = 10
        const max = 15
        const letters = '0123456789ABCDEF'
        let color = '#'

        const redIndex = Math.floor(Math.random() * (max - min + 1)) + min
        color += letters[redIndex]

        // Generate green component
        const greenIndex = Math.floor(Math.random() * (max - min + 1)) + min
        color += letters[greenIndex]

        // Generate blue component
        const blueIndex = Math.floor(Math.random() * (max - min + 1)) + min
        color += letters[blueIndex]
        return color
      }
    },
    setup () {
       // eslint-disable-next-line
        /* eslint-disable */
      const titleStack = ref(['Admin', 'Dashboard'])
      const isAsideMobileExpanded = computed(() => store.state.isAsideMobileExpanded)
      const { t } = useI18n()
      const router = useRouter()
      const isLoading = ref(false)
      const store = useStore()
      const darkMode = computed(() => store.state.darkMode)
      const toast = useToast()
        const capacityObject = ref()
        const detailModal = ref(false);
        const students = reactive({});
        const detailData = (event, capacity) => {
            detailModal.value = true;
            capacityObject.value = capacity
            refresh()
        };
        const refresh = async () => {
			  isLoading.value = true
        await axios
        .get('scheduletable', {
            params: filtered
        })
        .then(response => {
            rowData.value = response.data.data.schedule
            isLoading.value = false
        }).catch(error => {
            toast.error(error.response.data, { timeout: 5000 })
            console.log(error)
            isLoading.value = false
        })
       }
      const filtered = reactive({
        department_id: '',
        academic_year_id: '',
        class_id: '',
        subject_id: ''
      })
      const { departmentList } = getDepartmentData()
      const { academicYearList } = getAcademicYearData()
      const { classList } = getClassData()
      const academicYearListFilter = ref([])
      const classListFilter = ref([])
      watch(() => filtered.department_id, (newDep, oldDep) => {
        academicYearListFilter.value = computed(() => academicYearList.value.filter(item => item.department_id === newDep)).value
      })

      watch(() => filtered.academic_year_id, (newDep, oldDep) => {
        classListFilter.value = computed(() => classList.value.filter(item => item.department_id === filtered.department_id && item.academic_year_id === newDep)).value
      })

      const getMajor = reactive({});
      const subjectSave = async(env, check, type, last) => {
        isLoading.value = true;
        const url = "/rombel-save";
        const method = "POST";

        getMajor.student_id = students.id
        getMajor.subject_name = env
        getMajor.check = check
        getMajor.type = type
        getMajor.created_by = localStorage.getItem("email")
        getMajor.timelimit = rombel.countDown
        getMajor.last_select = last
        await axios({
            url,
            method,
            params: getMajor,
          })
          .then((response) => {
            getSubjectsParallelData()
            getData()
            rombel.start = true
            // isLoading.value = false;
        }).catch(error => {
            getSubjectsParallelData()
            getData()
            rombel.start = true
            toast.error(error.response.data, { timeout: 5000 })
            console.log(error)
            // isLoading.value = false
        })
      };

    const filter = reactive({
        major_ips: '',
        major_ipa: '',
        class_id: '',
        department_id: '',
        academic_year_id: ''
      })
      const showData = reactive([])
      const subjectGroupList = reactive([])
      const dataGroup = reactive([])
      const getData = async () => {
        const url = "/rombel-time";
        const method = "GET";
        await axios({
          url,
          method,
          params: filtered
        })
        .then(response => {
          showData.value = response.data.data
          dataGroup.value = response.data.group
          filterData.value = response.data.major
          subjectGroupList.value = response.data.subjectGroup


        }).catch(error => {
            toast.error(error.response.data, { timeout: 5000 })
            console.log(error)
            isLoading.value = false
        })
      }

      const filterData = reactive([])
      const getMajorName = async () => {
        const url = "/major";
        const method = "GET";
        await axios({
          url,
          method,
        })
        .then(response => {
          filterData.value = response.data.data
        }).catch(error => {
            toast.error(error.response.data, { timeout: 5000 })
            console.log(error)
            // isLoading.value = false
        })
      }
      watchEffect(() => {
        const newFilter = showData.value
        Object.assign(filtered, newFilter)

      });
      watchEffect(() => {
        const newGroup = dataGroup.value
        Object.assign(filtered, newGroup)

      });
      onMounted(() => {
        getData();
      });

      return {
        router,
        isLoading,
        t,
        toast,
        filter,
        titleStack,
        darkMode,
        mdiAccountMultiple,
        mdiCartOutline,
        mdiChartTimelineVariant,
        mdiFinance,
        mdiMonitorCellphone,
        mdiReload,
        mdiGithub,
        mdiMagnify,
        isAsideMobileExpanded,
        refresh,
        store,
        filtered,
        departmentList,
        academicYearList,
        academicYearListFilter,
        isAsideMobileExpanded,
        classList,
        classListFilter,
        subjectSave,
        getMajor,
        capacityObject,
        detailData,
        detailModal,
        mdiClose,
        mdiCogOutline,
        mdiTrashCan,
        filterData,
        getMajorName,
        filter,
        getData,
        showData,
        dataGroup,
        subjectGroupList
      }
    }
  }
  function currencyFormatter (currency, sign) {
      if (currency !== undefined) {
          const sansDec = Number(currency).toFixed()
          const formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          return `${formatted}`
      }
  }
</script>
<style >
.modal-wide {
  max-width: 800px;
}
.text-xs {
  padding-top: 3px;
  margin-top: 3px;
}
.grid-box{
    display: grid;
    grid-template-columns: auto auto;
}
@media screen and (max-width: 1280px){
  .left-content{
    width: 65%;
  }
  .title-container {
    margin-left: 15px;
  }
  .side-distance{
    margin-left: 15px !important;
  }
  .grid-box{
    grid-template-columns: auto;
  }
}
@media screen and (max-width: 768px){
    .full-page{
      flex-direction: column-reverse;
    }
    .left-content{
      width: 100%;
      padding-right: 15px;
      overflow: hidden;
    }
    .box-wrapper{
      width: auto;
      max-height: 250px;
      height: 250px;
      position: relative;
      top: 0;
      display: block;
      padding-top: 10px;
      margin-left: 15px;
      margin-right: 20px;
      margin-bottom: 0;
    }
    .box-container{
      display: grid;
      margin-bottom: 15px;
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
/* Dashboard Capacity */
.box-wrapper{
    /* border-left: 3px solid rgba(0, 0, 0, 0.25) !important; */
    width: -moz-max-content;
    width: 100%;
    height: 100%;
    border: 1px solid rgba(0, 0, 0, 0.05);
    overflow-y: scroll;
    overflow-x: hidden;
    margin: 35px 0px;
    position: sticky;
    max-height: 625px;
    top: 90px;
    overscroll-behavior: contain;
    background-color: white;
    border-radius: 8px;
    margin-right: 35px;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.25);
  }
  .box-wrapper::-webkit-scrollbar{
    display: none;
  }
  .box {
    align-items: center;
    padding: 10px 10px;
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
    width: 50%;
    margin: 0 auto 15px auto;
  }
  .vertical {
   /* display: flex; */
   vertical-align: bottom;
  }
  .box-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    padding: 20px 20px;
    /* margin-bottom: 15px; */
    width: 50%;

  }
  .box-container:nth-child(1){
    border-right: 1px solid rgba(0, 0, 0, 0.25);
    margin-top: 20px;
    padding-top: 0px;
    margin-bottom: 15px;
  }
.box-content{
  /* display: flex; */
  margin-bottom: 20px;
  padding: 10px;
  border-radius: 5px;
  background-color: whitesmoke;
  color: black;
  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
}
  .bar-precentage{
    height: 12px;
    border-radius: 4px;
  }
  .bar-green{
    height: 14px;
    border-radius: 4px;
    /* background-color: rgb(2, 220, 2); */
  }
  .bar-yellow{
    height: 14px;
    border-radius: 4px;
    background-color: yellow;
  }
  .bar-red{
    height: 14px;
    border-radius: 4px;
    background-color: red;
  }
  .bar-gray{
    height: 14px;
    border-radius: 4px;
    background-color: gray;
    pointer-events: none;
    cursor: not-allowed;
  }
  .full-container_ {
    width: 100% !important;
    height: auto;
    /* background-color: red; */
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    grid-template-columns: repeat(1, 1fr);
    column-gap: 20px;
    row-gap: 40px;
    padding-top: 20px;
    margin-bottom: 50px;
    padding-left: 30px !important;
    padding-right: 30px !important;
    position: relative;

}

.full-container_ .sub-container {
    width: 100%;
    height: auto;
    border: 2px solid gray;
}

.full-container_ .sub-container .title-group {
    width: 100%;
    text-align: center;
    font-weight: 600;
    font-size: 24px;
    color: black;
    margin-bottom: 12px;

}

.full-container_ .sub-container .container-group {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    column-gap: 20px;
    row-gap: 40px;
}

@media (min-width: 640px) {
    .full-container_ .sub-container .container-group {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (min-width: 1024px) {
    .full-container_ .sub-container .container-group {
        grid-template-columns: repeat(5, 1fr);
    }
}

@media (min-width: 1280px) {
    .full-container_ {
        grid-template-columns: repeat(2, 1fr);
    }
}

.full-container_ .sub-container .container-group .card-group {
    width: 100%;
    min-height: 120px;
}

.container-group .card-group .header-content {
    width: 100%;
    /* background-color: yellow; */
    text-align: center;
    font-weight: 700;
    font-size: 20px;
    color:  black;
}

.container-group .card-group .sub-content {
    width: 100%;
    display: grid;
    padding: 8px;
}

.container-group .card-group .sub-content .content {
    width: 100%;
    /* background-color: pink; */
    font-weight: 500;
    font-size: 14px;
    padding: 8px;
    margin-bottom: 12px;
}

.container-group .card-group .sub-content .content:nth-last-child(1) {
    margin-bottom: 0;
}

.sub-content .content .title-content {
    width: 100%;
    font-weight: 700;
    font-size: 16px !important;
    margin-bottom: 8px;
}

.sub-content .content table {
    width: 100%;
    margin-bottom: 8px;
}

.sub-content .content table tr td {
    font-size: 12px;
}

.sub-content .content table tr td:nth-child(1) {
    font-weight: 600;
    width: 80px;
    vertical-align: top;
}
.sub-content .content table tr td:nth-child(2) {
    font-weight: 600;
    width: 10px;
    text-align: center;
    vertical-align: top;
}

.sub-content .content .bar-capacity {
    width: 100%;
    height: 14px !important;
    background-color: lightgray;
    position: relative;
    margin-top: 1px;
}

/* .sub-content .content .bar-capacity .bar-value {
    width: 60%;
    height: 16px;
    margin-top: 1px;

} */
.wide-modal {
  width: 100% !important;
}
</style>

